import React, { useState, useEffect, useRef, useCallback, memo } from "react";
import { Link } from "react-router-dom";
import SimpleReactValidator from "simple-react-validator";
import PhoneInputField from "components/Inputs/PhoneInputField";
import API from "api.js";
import { store } from "store/index";

const Footer = memo(() => {
  // State declarations
  const [indexModal, setIndexModal] = useState(false);
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [center, setCenter] = useState("");
  const [process, setProcess] = useState(false);
  const [taskModal, setTaskModal] = useState(false);
  const [taskSuccessBag, setTaskSuccessBag] = useState("");
  const [taskErrorBag, setTaskErrorBag] = useState("");
  const [taskName, setTaskName] = useState("");
  const [taskPhone, setTaskPhone] = useState("");
  const [taskEmail, setTaskEmail] = useState("");
  const [taskInstitute, setTaskInstitute] = useState("");
  const [branches, setBranches] = useState([]);
  const [forceUpdateKey, setForceUpdateKey] = useState(0);

  // Validator reference
  const validator = useRef(new SimpleReactValidator());

  // Force re-render for validator messages
  const forceUpdate = useCallback(() => {
    setForceUpdateKey((prev) => prev + 1);
  }, []);

  // Lifecycle: componentDidMount
  useEffect(() => {
    if (!store.getState().token) {
      const timer = setTimeout(() => {
        setIndexModal(true);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  // Event handlers
  const closeIndexModal = useCallback((event) => {
    event.preventDefault();
    setIndexModal(false);
  }, []);

  const changeInput = useCallback((e) => {
    const { name, value } = e.target;
    switch (name) {
      case "name":
        setName(value);
        break;
      case "phone":
        setPhone(value);
        break;
      case "email":
        setEmail(value);
        break;
      case "center":
        setCenter(value);
        break;
      default:
        break;
    }
  }, []);

  const handlePhoneChange = useCallback((event) => {
    setPhone(event);
  }, []);

  const postSubmit = useCallback(
    async (e) => {
      e.preventDefault();
      if (!validator.current.allValid()) {
        validator.current.showMessages();
        forceUpdate();
        return false;
      }

      setProcess(true);
      const bodyFormData = new FormData();
      bodyFormData.append("phone", phone);
      bodyFormData.append("name", name);
      bodyFormData.append("email", email);
      bodyFormData.append("center", center);

      let res = null;
      try {
        res = await API({
          method: "POST",
          url: "/submit-query",
          data: bodyFormData,
        });
      } catch (error) {
        if (error.response && error.response.status === 422) {
          let str = "";
          Object.values(error.response.data.errors).forEach((val) => {
            str += val[0] + "\n";
          });
          setTaskErrorBag(str);
          setProcess(false);
        } else {
          setProcess(false);
        }
        return;
      }

      if (res?.status === 200) {
        setIndexModal(false);
        window.location.href = "/trial-class-thankyou";
      }
    },
    [name, phone, email, center, forceUpdate],
  );

  // Render
  return (
    <React.Fragment>
      {/* <footer id="pte-footer" className="d-none">
        <div className="container">
          {store.getState().is_main && (
            <div>
              <div className="footer-logo">
                <Link to="/">
                  <img src="/images/web-new-images/footer-logo.png" alt="LA" />
                </Link>
              </div>
              <div className="row footer-row">
                <div className="col footerWidget">
                  <h3>PTE</h3>
                  <ul>
                    <li>
                      <Link to="/pte-coaching-classes-parramatta">
                        About PTE
                      </Link>
                    </li>
                    <li>
                      <Link to="/pte-core">About PTE Core</Link>
                    </li>
                    <li>
                      <Link to="/pte-online-classes">Online classes</Link>
                    </li>
                    <li>
                      <Link to="/pte-study-material">Study Material</Link>
                    </li>
                  </ul>
                </div>
                <div className="col footerWidget">
                  <h3>NAATI</h3>
                  <ul>
                    <li>
                      <Link to="/naati-ccl-online-coaching">
                        NAATI Hindi Coaching
                      </Link>
                    </li>
                    <li>
                      <Link to="/naati-ccl-online-coaching">
                        NAATI Punjabi Coaching
                      </Link>
                    </li>
                    <li>
                      <Link to="/naati-ccl-online-coaching">
                        NAATI Urdu Coaching
                      </Link>
                    </li>
                    <li>
                      <Link to="/naati-ccl-online-coaching">
                        NAATI Nepali Coaching
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="col footerWidget">
                  <h3>ABOUT US</h3>
                  <ul>
                    <li>
                      <Link to="/about">Our Story</Link>
                    </li>
                    <li>
                      <Link to="/sitemap">Sitemap</Link>
                    </li>
                    <li>
                      <Link to="/join-us">Career</Link>
                    </li>
                    <li>
                      <Link to="/franchise">Franchise</Link>
                    </li>
                  </ul>
                </div>

                <div className="col footerWidget">
                  <h3>PRACTICE MATERIAL</h3>
                  <ul>
                    <li>
                      <Link to="/pte-reading-test-practice-material">
                        Reading
                      </Link>
                    </li>
                    <li>
                      <Link to="/pte-writing-test-practice-material">
                        Writing
                      </Link>
                    </li>
                    <li>
                      <Link to="/pte-listening-test-practice-material">
                        Listening
                      </Link>
                    </li>
                    <li>
                      <Link to="/pte-speaking-test-practice-material">
                        Speaking
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="row footer-contact-info">
                <div className="col-md-7 col-lg-9">
                  <div className="contact-info">
                    <h3>Contact Us</h3>
                    <ul>
                      <li>
                        <a href="mailto:info@languageacademy.com.au">
                          <span>info@languageacademy.com.au</span>
                        </a>
                      </li>
                      <li>
                        <a href="tel:61426230061">
                          <span>+61 426230061</span>
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://goo.gl/maps/bhiU4au3764eDjVu8"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <span>46 George Street, Parramatta</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-5 col-lg-3 footer-social-wrapper">
                  <h3>Follow Us</h3>
                  {store.getState().is_main && (
                    <div className="footer-social-icons">
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://www.facebook.com/languageacademyaustralia/"
                      >
                        <img
                          src="/images/web-new-images/icons/facebook-icon.svg"
                          alt="LA"
                        />
                      </a>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://www.linkedin.com/authwall?trk=gf&trkInfo=AQGxYvTu-VIE8gAAAXQBcysYhyoeMLsNbqRf-PuswFI8RzAL5y60LYHKbYMYZBVifPWMn7AFIF4-pI_yN6twk7IVrKwK8kV3mABFKcSSuEZ6xhISNB9XifF45GiA8j3LNNc6bZo=&originalReferer=https://www.languageacademy.com.au/sitemap.html&sessionRedirect=https%3A%2F%2Fwww.linkedin.com%2Fcompany%2Flanguage-academy-australia"
                      >
                        <img
                          src="/images/web-new-images/icons/linkedin-icon.svg"
                          alt="LA"
                        />
                      </a>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://www.instagram.com/languageacademyau/"
                      >
                        <img
                          src="/images/web-new-images/icons/insta-icon.svg"
                          alt="LA"
                        />
                      </a>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://twitter.com/lang_acad_au"
                      >
                        <img
                          src="/images/web-new-images/icons/x-icon.svg"
                          alt="LA"
                        />
                      </a>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://www.youtube.com/channel/UC-yXI8Y7cry-D5uuNGbYbsw"
                      >
                        <img
                          src="/images/web-new-images/icons/youtube-icon.svg"
                          alt="LA"
                        />
                      </a>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
          <div className="row bottomFooter">
            <div className="col-md-6 pl-0">
              <p className="copyright">
                Copyright © {new Date().getFullYear()} LanguageAcademy. All
                rights reserved
              </p>
            </div>
            <div className="col-md-6 pr-0">
              <ul>
                <li>
                  <Link to="/term">Terms of Use</Link>
                </li>
                <li className="separator"></li>
                <li>
                  <Link to="/privacy-policy">Privacy Policy</Link>
                </li>
                <li className="separator"></li>
                <li>
                  <Link to="/refund-policies">Refund Policies</Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer> */}

      <footer
        id="pte-footer"
        className="pt-5 pb-3 new-design mt-5"
        style={{
          color: "white",
          backgroundColor: "#0D1830",
          backgroundImage:
            "radial-gradient(circle at bottom right,#7F56D9 0%,rgba(127, 86, 217, 0.4) 8%,rgba(127, 86, 217, 0.2) 15%,transparent 25%)",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="custom-container" style={{color:'#C7C7C7'}}>
          {/* TOP SECTION */}
          <div className="row gy-4">
            {/* LEFT LOGO + TEXT */}
            <div className="col-lg-2">
              <div className="footer-logo mb-3">
                <Link to="/">
                  <img
                    src="/images/web-new-images/new-footer-icon.png"
                    alt="LA"
                  />
                </Link>
              </div>
              <p className="mb-0 plus-sans FS16FW500" style={{color:'#C7C7C7'}}>
                At Language Academy, you can be assured that you will be
                learning from the best in the industry.
              </p>
            </div>
            {/* Middle Line Column */}
          <div className="col-1 justify-content-center d-flex align-items-center">
            <div className="divider-line"></div>
          </div>
            <div className="col-lg-9 plus-sans">
              <div className="row">
                {/* PTE */}
                <div className="col-6 col-md-3">
                  <h6 className="mb-3 FS20FW500 fw-600 text-white">PTE</h6>
                  <ul className="list-unstyled">
                    <li>
                      <Link to="/pte-coaching-classes-parramatta">
                        About PTE
                      </Link>
                    </li>
                    <li>
                      <Link to="/pte-core">About PTE Core</Link>
                    </li>
                    <li>
                      <Link to="/pte-online-coaching">Online Classes</Link>
                    </li>
                    <li>
                      <Link to="/pte-study-material">Study Material</Link>
                    </li>
                  </ul>
                </div>

                {/* NAATI */}
                <div className="col-6 col-md-3">
                  <h6 className="FS20FW500 fw-600 mb-3 text-white">NAATI</h6>
                  <ul className="list-unstyled">
                    <li>
                      <Link to="/naati-ccl-online-coaching">NAATI Nepali Coaching</Link>
                    </li>
                    <li>
                      <Link to="/naati-ccl-online-coaching">NAATI Punjabi Coaching</Link>
                    </li>
                    <li>
                      <Link to="/naati-ccl-online-coaching">NAATI Urdu Coaching</Link>
                    </li>
                    <li>
                      <Link to="/naati-ccl-online-coaching">NAATI Hindi Coaching</Link>
                    </li>
                  </ul>
                </div>

                {/* ABOUT */}
                <div className="col-6 col-md-3">
                  <h6 className="FS20FW500 fw-600 mb-3 text-white" style={{textTransform:'unset'}}>About Us</h6>
                  <ul className="list-unstyled">
                    <li>
                      <Link to="/about">Our Story</Link>
                    </li>
                    <li>
                      <Link to="/sitemap">Sitemap</Link>
                    </li>
                    <li>
                      <Link to="/join-us">Career</Link>
                    </li>
                    <li>
                      <Link to="/franchise">Franchise</Link>
                    </li>
                  </ul>
                </div>

                {/* PRACTICE */}
                <div className="col-6 col-md-3">
                  <h6 className="FS20FW500 fw-600 mb-3 text-white" style={{textTransform:'unset'}}>Practice Material</h6>
                  <ul className="list-unstyled">
                    <li>
                      <Link to="/pte-reading-test-practice-material">
                        Reading
                      </Link>
                    </li>
                    <li>
                      <Link to="/pte-writing-test-practice-material">
                        Writing
                      </Link>
                    </li>
                    <li>
                      <Link to="/pte-listening-test-practice-material">
                        Listening
                      </Link>
                    </li>
                    <li>
                      <Link to="/pte-speaking-test-practice-material">
                        Speaking
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              {/* <hr className="my-4" /> */}
              <div className="col-12 footer-bottom-contact mt-5">
                {/* CONTACT ROW */}
                <div className="row align-items-center gy-3">
                  {/* CALL */}
                  <div className="col-md-3">
                    <p className="fw-semibold" style={{marginBottom:'18px'}}>Call Us</p>
                    <a href="tel:61426230061">+61 426230061</a>
                  </div>

                  {/* INQUIRY */}
                  <div className="col-md-3" style={{ wordWrap: "break-word" }}>
                    <p className="fw-semibold" style={{marginBottom:'18px'}}>Inquiry</p>
                    <a href="mailto:info@languageacademy.com.au">
                      info@languageacademy.com.au
                    </a>
                  </div>

                  {/* ADDRESS */}
                  <div className="col-md-3">
                    <p className="fw-semibold" style={{marginBottom:'18px'}}>Visit Us</p>
                    <span style={{color:'#FFFFFF'}}>46 George Street, Parramatta</span>
                  </div>

                  {/* SOCIAL */}
                  <div className="col-md-3">
                    <p className="mb-2 fw-semibold">Follow Us On</p>
                    <div className="d-flex gap-3">
                      <a href="https://www.facebook.com/languageacademyaustralia/" target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Facebook"
>
                        <img
                          src="/images/web-new-images/icons/fb-white.svg"
                          alt="Facebook Icon"
                        />
                      </a>
                      <a href="https://www.linkedin.com/feed/" target="_blank"
                        rel="noopener noreferrer"
                        aria-label="LinkedIn"
>
                        <img
                          src="/images/web-new-images/icons/linkedin-white.svg"
                          alt="LinkedIn"
                        />
                      </a>
                      <a href="https://www.instagram.com/languageacademyau/" target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Instagram"
                      >
                        <img
                          src="/images/web-new-images/icons/insta-white.svg"
                          alt="Instagram"
                        />
                      </a>
                      <a href="https://x.com/lang_acad_au" target="_blank"
                        rel="noopener noreferrer"
                        aria-label="X"
                      >
                        <img
                          src="/images/web-new-images/icons/x-white.svg"
                          alt="X"
                        />
                      </a>
                      <a href="https://www.youtube.com/channel/UC-yXI8Y7cry-D5uuNGbYbsw" target="_blank"
                        rel="noopener noreferrer"
                        aria-label="YouTube"
                      >
                        <img
                          src="/images/web-new-images/icons/yt-white.svg"
                          alt="YouTube"
                        />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* BOTTOM BAR */}
          <hr className="my-4" />

          <div className="d-flex flex-column flex-md-row justify-content-between align-items-center gap-2">
            <p className="mb-0">
              Copyright © {new Date().getFullYear()} LanguageAcademy. All rights
              reserved
            </p>

            <div className="d-flex gap-3 policies">
              <Link to="/term">Terms of Use</Link>
              <span>•</span>
              <Link to="/privacy-policy">Privacy Policy</Link>
              <span>•</span>
              <Link to="/refund-policies">Refund Policies</Link>
            </div>
          </div>
        </div>
      </footer>

      {/* Modal */}
      <div
        className="modal fade"
        id="staticBackdrop"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog main-popup">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  const modalEl = document.getElementById('staticBackdrop');
                  modalEl.classList.remove('show');
                  modalEl.style.display = 'none';
                  document.body.classList.remove('modal-open');
                  document.body.style.removeProperty('overflow');
                  document.body.style.removeProperty('padding-right');
                  const backdrop = document.querySelector('.modal-backdrop');
                  if (backdrop) backdrop.remove();
                }}
              >
                <span aria-hidden="true">
                  <img
                    className="img-fluid"
                    src="/images/web-new-images/icons/close-icon2.svg"
                    alt="LA"
                  />
                </span>
              </button>
            </div>
            <div className="modal-body p-0">
              <div className="form-content-outer m-0">
                <div className="form-content">
                  <div className="main-popup-img form-img">
                    <img
                      className="img-fluid"
                      src="/images/web-new-images/hero_img-02.png"
                      alt="LA"
                    />
                  </div>
                  <div className="main-popup-content form-content-right">
                    <h4 className="popup-title">
                      Attend a FREE TRIAL CLASS for PTE, NAATI CCL or IELTS with
                      us.
                    </h4>
                    <p className="popup-sub-title">Submit Your Details Below</p>
                    <div className="pte-popup-form-start">
                      <form onSubmit={postSubmit}>
                        <div className="col-md-12">
                          <div className="fieldOuter">
                            <label htmlFor="Name">Name*</label>
                            <div className="form-input-outer">
                              <input
                                id="Name"
                                className="form-input"
                                name="name"
                                placeholder="Enter Name"
                                type="text"
                                value={name}
                                onChange={changeInput}
                              />
                            </div>
                            {validator.current.message(
                              "name",
                              name,
                              "required",
                            )}
                          </div>
                        </div>

                        <div className="col-md-12">
                          <div className="fieldOuter">
                            <label htmlFor="PhoneNumber">Phone Number</label>
                            <PhoneInputField
                              value={phone}
                              changeEvent={handlePhoneChange}
                              addClass="popup-class"
                            />
                            {validator.current.message(
                              "phone",
                              phone,
                              "required|phone",
                            )}
                          </div>
                        </div>

                        <div className="col-md-12">
                          <div className="fieldOuter">
                            <label htmlFor="email">Email*</label>
                            <div className="form-input-outer">
                              <input
                                id="email"
                                className="form-input"
                                name="email"
                                placeholder="Enter Email"
                                type="email"
                                value={email}
                                onChange={changeInput}
                              />
                            </div>
                            {validator.current.message(
                              "email",
                              email,
                              "required|email",
                            )}
                          </div>
                        </div>

                        <div className="col-md-12">
                          <div className="fieldOuter">
                            <label htmlFor="Center">Center</label>
                            <div className="form-input-outer form-select-wrapper">
                              <select
                                id="Center"
                                className="form-input"
                                name="center"
                                value={center}
                                onChange={changeInput}
                              >
                                <option value="">Select center</option>
                                <option>Parramatta</option>
                                <option>Sydney CBD</option>
                                <option>Jalandhar</option>
                                <option>Gurdaspur</option>
                                <option>Amristar</option>
                                <option>Sirsa</option>
                                <option>Sri Ganganagar</option>
                                <option>Kurukshetra</option>
                                <option>Online</option>
                              </select>
                            </div>
                            {validator.current.message(
                              "center",
                              center,
                              "required",
                            )}
                          </div>
                        </div>

                        <div className="col-md-12 row_before_pte_submit">
                          {!process ? (
                            <button type="submit" className="primary-btn">
                              SUBMIT{" "}
                              <img
                                src="/images/web-new-images/new-dark-arrow.svg"
                                alt="LA"
                              />
                            </button>
                          ) : (
                            <button
                              className="btn btn-primary pte_popup_modal_submit"
                              disabled
                            >
                              Wait...
                            </button>
                          )}
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
});

export default Footer;
